import React from 'react';
import OnboardingCardSC, { CardTopSC } from './onboarding-card.styled';
import { BodyText } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import { ReactComponent as SuccesCheckIcon } from '../../../assets/img/svg/success-check.svg';
import { ReactComponent as WaitingClockIcon } from '../../../assets/img/svg/waiting-clock.svg';
import { ReactComponent as ErrorCheckIcon } from '../../../assets/img/svg/error-check.svg';
import { ReactComponent as AlertCheckIcon } from '../../../assets/img/svg/alert-check.svg';
import { FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

const OnboardingCard = ({
  personalNumber,
  loading,
  showLoading = true,
  isRefused,
  status,
  opened,
  children,
  headline,
  subtexts,
  subtextDone,
  headlineDone,
  headlineVerticalCenter = false,
  waitingHeadline,
  waitingSubtext,
  onRenderAction,
  className,
}) => {
  useEffect(() => {
    if (onRenderAction !== null || onRenderAction !== undefined) {
      onRenderAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OnboardingCardSC className={className ? className : ''}>
      <CardTopSC className={className ? className : ''} loading={loading}>
        <div
          className={`left-side ${loading ? 'loading' : ''} ${
            headlineVerticalCenter ? 'centered' : ''
          }`}
        >
          {status === 'waiting' && waitingHeadline ? (
            <BodyText className="bolder dark-orange">
              <FormattedHTMLMessage
                id={waitingHeadline}
                defaultMessage={dlt[`${waitingHeadline}`]}
              />
            </BodyText>
          ) : status === 'done' && headlineDone ? (
            <BodyText className={className === 'completed' ? 'bolder white' : 'bolder'}>
              <FormattedHTMLMessage id={headlineDone} defaultMessage={dlt[`${headlineDone}`]} />
            </BodyText>
          ) : (
            <BodyText className={isRefused ? 'bolder white' : 'bolder'}>
              <FormattedHTMLMessage id={headline} defaultMessage={dlt[`${headline}`]} />
            </BodyText>
          )}
          {status === 'waiting' && waitingSubtext ? (
            <BodyText className="bolder dark-orange-transparent">
              <FormattedHTMLMessage id={waitingSubtext} defaultMessage={dlt[`${waitingSubtext}`]} />
            </BodyText>
          ) : status === 'done' ? (
            <BodyText
              className={
                isRefused
                  ? 'white bolder'
                  : className === 'completed'
                  ? 'white bolder'
                  : 'black-transparent-lighter bolder'
              }
            >
              {subtextDone !== '' ? (
                <FormattedHTMLMessage id={subtextDone} defaultMessage={dlt[`${subtextDone}`]} />
              ) : (
                ''
              )}
            </BodyText>
          ) : (
            <>
              {(subtexts || []).map((subtext, key) => (
                <BodyText
                  key={key}
                  className={className === 'confirmation-pending' ? 'dark-orange bolder' : ''}
                >
                  <FormattedHTMLMessage id={subtext} defaultMessage={dlt[`${subtext}`]} />{' '}
                  {personalNumber ? personalNumber : null}
                </BodyText>
              ))}
            </>
          )}
        </div>

        <div className="right-side">
          {loading && showLoading ? (
            <InlineLoading className={className === 'confirmation-pending' ? 'white' : ''} />
          ) : null}
          {isRefused ? (
            <ErrorCheckIcon />
          ) : status === 'waiting' ? (
            <AlertCheckIcon />
          ) : status === 'done' ? (
            <SuccesCheckIcon />
          ) : className === 'confirmation-pending' ? (
            <SuccesCheckIcon />
          ) : (
            <WaitingClockIcon />
          )}
        </div>
      </CardTopSC>
      {opened ? <>{children}</> : null}
    </OnboardingCardSC>
  );
};

OnboardingCard.propTypes = {
  loading: PropTypes.bool,
  status: PropTypes.string,
  opened: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headline: PropTypes.string,
  subtext: PropTypes.string,
  subtextDone: PropTypes.string,
  headlineDone: PropTypes.string,
  className: PropTypes.string,
  isRefused: PropTypes.bool,
  waitingSubtext: PropTypes.string,
  waitingHeadline: PropTypes.string,
};

OnboardingCard.defaultProps = {
  loading: false,
  isRefused: false,
  status: 'pending',
  opened: false,
  children: null,
  headline: '',
  subtext: '',
  subtextDone: '',
  headlineDone: '',
  waitingSubtext: '',
  waitingHeadline: '',
  className: '',
};

export default OnboardingCard;
